import { render, staticRenderFns } from "./VarietySummary.vue?vue&type=template&id=16a8ed5c&scoped=true&lang=pug&"
import script from "./VarietySummary.vue?vue&type=script&lang=js&"
export * from "./VarietySummary.vue?vue&type=script&lang=js&"
import style0 from "./VarietySummary.vue?vue&type=style&index=0&id=16a8ed5c&lang=scss&scoped=true&"
import style1 from "./VarietySummary.vue?vue&type=style&index=1&id=16a8ed5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a8ed5c",
  null
  
)

export default component.exports